// extracted by mini-css-extract-plugin
export var image = "gl_dr";